import React from "react";
import { useRemoteOptions } from "../../hooks/useRemoteOptions.js";
import type { FilterOption, RemoteFilterOptions } from "./filter-schema.js";

interface RemoteFilterOptionsState {
  readonly query: string;
  readonly options: readonly FilterOption[];
  readonly nextCursor: string | null;
  readonly loading: boolean;
  readonly loadingMore: boolean;
  readonly failed: boolean;
  readonly loadMoreFailed: boolean;
  readonly updateQuery: (query: string) => void;
  readonly loadNextPage: () => void;
  readonly retry: () => void;
}

/**
 * Remote option request state for FilterOptionList. The request engine —
 * timing, cancellation, retry and cursor pagination — is `useRemoteOptions`,
 * shared with Combobox's `loadOptions`; this adapter only owns the search text
 * and reads the field's `RemoteFilterOptions` source. Caching stays in the
 * module-provided loader.
 */
export function useRemoteFilterOptions(
  source: RemoteFilterOptions,
): RemoteFilterOptionsState {
  const [query, setQuery] = React.useState("");
  const state = useRemoteOptions<FilterOption>({
    load: source.load,
    query,
    debounceMs: source.debounceMs,
  });
  return { ...state, query, updateQuery: setQuery };
}
